// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"53b21df0","85":"a5a7be55","311":"8dab3b48","777":"dd9c5cda"}[chunkId] + ".js";
};